import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import dexterLogo from "../../assets/dexter-logo.png";

function Header({ isMenuOpen, setIsMenuOpen }) {
  const { scrollY } = useScroll();
  const headerY = useTransform(scrollY, [0, 100], [0, -100]);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Close dropdown when toggling mobile menu
    if (isMenuOpen) {
      setActiveDropdown(null);
    }
  };

  const handleNavClick = (path) => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
    navigate(path);
  };

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };

  // Close dropdown when mobile menu closes
  useEffect(() => {
    if (!isMenuOpen) {
      setActiveDropdown(null);
    }
  }, [isMenuOpen]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const servicesSubMenus = [
    {
      path: "/services/machining-capabilities",
      label: "Machining Capabilities",
    },
    { path: "/services/industry-served", label: "Industry Served" },
    {
      path: "/services/quality-testing",
      label: "Quality Testing & Inspection",
    },
    {
      path: "/services/raw-materials",
      label: "Processed Raw Materials & Treatments",
    },
  ];

  return (
    <motion.header className="header" style={{ y: headerY }}>
      <div className="container">
        <div
          className="logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img
            src={dexterLogo}
            alt="DexteR Technology Logo"
            className="logo-image"
          />
          <div className="logo-text">
            <span className="logo-main">DEXTE</span>
            <span className="logo-sub">TECHNOLOGY</span>
          </div>
        </div>

        <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
          <button
            className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            onClick={() => handleNavClick("/")}
          >
            Home
          </button>

          <button
            className={`nav-link ${
              location.pathname === "/about" ? "active" : ""
            }`}
            onClick={() => handleNavClick("/about")}
          >
            About Us
          </button>

          <div className="nav-dropdown" ref={dropdownRef}>
            <button
              className={`nav-link dropdown-toggle ${
                location.pathname.startsWith("/services") ? "active" : ""
              }`}
              onClick={() => toggleDropdown("services")}
              aria-expanded={activeDropdown === "services"}
              aria-haspopup="true"
            >
              <span className="services-text">Services</span>
              <FaChevronDown
                className={`dropdown-arrow ${
                  activeDropdown === "services" ? "rotated" : ""
                }`}
              />
            </button>
            <div
              className={`dropdown-menu ${
                activeDropdown === "services" ? "show" : ""
              }`}
              aria-hidden={activeDropdown !== "services"}
            >
              {servicesSubMenus.map((subMenu) => (
                <button
                  key={subMenu.path}
                  className={`dropdown-item ${
                    location.pathname === subMenu.path ? "active" : ""
                  }`}
                  onClick={() => handleNavClick(subMenu.path)}
                >
                  {subMenu.label}
                </button>
              ))}
            </div>
          </div>

          <button
            className={`nav-link ${
              location.pathname === "/contact" ? "active" : ""
            }`}
            onClick={() => handleNavClick("/contact")}
          >
            Contact Us
          </button>
        </nav>

        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </motion.header>
  );
}

export default Header;
